// Copyright (c) 2025 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import {
  BatchGetTimesheetFieldConfigsRequest,
  CreateTimesheetFieldOptionRequest,
  CreateTimesheetFieldRequest,
  DeleteTimesheetFieldOptionRequest,
  DeleteTimesheetFieldRequest,
  DisableTimesheetFieldOptionsRequest,
  EnableTimesheetFieldOptionsRequest,
  GenerateTimesheetFieldConfigsRequest,
  ListTimesheetFieldOptionsRequest,
  UpdateTimesheetFieldOptionRequest,
  UpdateTimesheetFieldRequest,
} from "../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

export type Payload<T> = {
  request: T,
  onSuccess?: () => void,
  onError?: () => void,
}
export const listTimesheetFieldOptions = createAction<ListTimesheetFieldOptionsRequest>("timesheet-fields/list-timesheet-field-options")
export const generateTimesheetFieldConfigs = createAction<GenerateTimesheetFieldConfigsRequest>("timesheet-fields/generate-timesheet-field-configs")
export const batchGetTimesheetFieldConfigs = createAction<BatchGetTimesheetFieldConfigsRequest>("timesheet-fields/batch-get-timesheet-field-configs")
export const createTimesheetField = createAction<Payload<CreateTimesheetFieldRequest>>("timesheet-fields/create-timesheet-field")
export const updateTimesheetField = createAction<Payload<UpdateTimesheetFieldRequest>>("timesheet-fields/update-timesheet-field")
export type UpdateTimesheetFieldOptionPayload = Payload<UpdateTimesheetFieldOptionRequest> & { timesheetFieldId: string }
export const updateTimesheetFieldOption = createAction<UpdateTimesheetFieldOptionPayload>("timesheet-fields/update-timesheet-field-option")
export const deleteTimesheetField = createAction<Payload<DeleteTimesheetFieldRequest>>("timesheet-fields/delete-timesheet-field")
export const createTimesheetFieldOption = createAction<Payload<CreateTimesheetFieldOptionRequest>>("timesheet-fields/create-timesheet-field-option")
export type DeleteTimesheetFieldOptionPayload = Payload<DeleteTimesheetFieldOptionRequest> & { timesheetFieldId: string }
export const deleteTimesheetFieldOption = createAction<DeleteTimesheetFieldOptionPayload>("timesheet-fields/delete-timesheet-field-option")
export const enableTimesheetFieldOptions = createAction<EnableTimesheetFieldOptionsRequest>("timesheet-fields/enable-timesheet-field-options")
export const disableTimesheetFieldOptions = createAction<DisableTimesheetFieldOptionsRequest>("timesheet-fields/disable-timesheet-field-options")
